import { AGENT_TYPES } from '../constants/agentTypes';
import { WORK_HONESTLY_MESSAGES } from '../constants/workHonestly';

export const getProofMessage = (type?: AGENT_TYPES) => {
  return type ? WORK_HONESTLY_MESSAGES[type] : WORK_HONESTLY_MESSAGES[AGENT_TYPES.Agent];
};
